import { ca } from '@cian/analytics';

interface ITrackOpenChatParams {
  label: string;
  placeType: string;
}

export function trackOpenChat({ label, placeType }: ITrackOpenChatParams) {
  ca('eventSite', {
    action: 'open',
    category: 'Message_popup',
    label,
    name: 'oldevent',
    useLastProducts: true,
    page: {
      extra: {
        type: placeType,
      },
    },
  });
}
